import React, { Fragment, useState } from "react"
import { toJsonShape } from "../../../helpers/helpers"
import { SourceSheetProps } from "./SourceSheetProps"
import "./SourceSheet.scss";

export const SourceSheet = (props: SourceSheetProps) => {
    const [sefariaContent] = useState(toJsonShape(props.source.content))

    const renderThumbnail = () => {
        let photo;
        if (props.contentMeta.thumbnail) {
            photo = <div className="row justify-content-center">
                <img alt={props.contentMeta.thumbnail} className="post-photo" src={props.contentMeta.thumbnail}></img>
            </div>
        }
        return photo;
    }


    const renderHeAndTextShape = () => {
        return sefariaContent && sefariaContent.he && sefariaContent.text ? (
            <div className="pages-wrapper my-5 ">
                <div className="sefaria-wrapper">
                    {
                        sefariaContent.he.map((h: any, i: number) => (
                            <div className="my-4" key={i}>
                                <div className="my-2 text-right" dangerouslySetInnerHTML={{ __html: h }}></div>
                                {sefariaContent.text[i] ? <div className="my-2 text-left" dangerouslySetInnerHTML={{ __html: sefariaContent.text[i] }}></div> : null}
                            </div>
                        )
                        )
                    }
                </div>
                <div className="under-page"></div>
            </div>
        ) : null
    }

    const renderSourcesShape = () => {

        return sefariaContent && sefariaContent.sources ? (
            <div className="pages-wrapper my-5 ">
                <div className="sefaria-wrapper">
                    {
                        sefariaContent.sources.map((s: any, i: number) => (
                            <div className="my-4" key={i}>
                                { s.outsideText ? <Fragment>
                                    <div className={sefariaContent.sheetLanguage === "hebrew" ? 'text-right my-2 text-rtl' : 'text-left my-2'} dangerouslySetInnerHTML={{ __html: s.outsideText }}></div>
                                </Fragment> : null}
                                {s.outsideBiText ? <Fragment>
                                    <div className="my-2 text-right text-rtl" dangerouslySetInnerHTML={{ __html: s.outsideBiText.he }}></div>
                                    <div className="my-2 text-left" dangerouslySetInnerHTML={{ __html: s.outsideBiText.en }}></div>
                                </Fragment> : null}
                                {s.text ? <Fragment>
                                    <div className="my-2 text-right origin text-rtl" dangerouslySetInnerHTML={{ __html: s.heRef }}></div>
                                    <div className="my-2 text-right text-rtl" dangerouslySetInnerHTML={{ __html: s.text.he }}></div>

                                    <div className="my-2 text-left origin" dangerouslySetInnerHTML={{ __html: s.ref }}></div>
                                    <div className="my-2 text-left" dangerouslySetInnerHTML={{ __html: s.text.en }}></div>
                                </Fragment> : null}
                            </div>
                        )
                        )
                    }
                </div>
                <div className="under-page"></div>
            </div>
        ) : null
    }


    return <React.Fragment>
        {renderHeAndTextShape()}
        {renderThumbnail()}
        {renderSourcesShape()}
    </React.Fragment>
}